export const BASE_URL = "";
// export const BASE_URL = "https://devchatbot.reece.com"

// Use this Base URL for local testing for development server
// export const BASE_URL = "http://127.0.0.1:8000";

// const isProduction = window.location.hostname.includes("reece.com");

// export const BASE_URL = isProduction
//   "https://devchatbot.reece.com"
//   : "http://127.0.0.1:8000";

// console.log("🌐 utils.js BASE_URL:", BASE_URL);

export const getConversationType = () => {
  return localStorage.getItem("conversation_type");
};

export const getConversationId = async () => {
  try {
    const body = JSON.stringify({ channel: getConversationType() });
    const response = await fetch(`${BASE_URL}/common/create_conversation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
    const data = await response.json();
    return data["id"];
  } catch (error) {
    return "";
  }
};

export const validateUser = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/authentication/validation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: token }),
    });

    if (response.ok) return true;
    else if (response.status === 403) return false;
    else return false;
  } catch (error) {
    return false;
  }
};

export const sendFeedback = async (conversationId, feedbackText, metadata = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/common/submit_feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        conversation_id: conversationId,
        feedback_msg: feedbackText,
        ...metadata
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Failed to submit feedback");
    }

    const data = await response.text();
    return { success: data };
  } catch (error) {
    console.error("Error submitting feedback:", error);
    throw error;
  }
};

export const sendPositiveFeedback = async (conversationId, messageId) => {
  try {
    const response = await fetch(`${BASE_URL}/common/submit_positive_feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        conversation_id: conversationId,
        message_id: messageId
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to submit positive feedback");
    }

    return { success: true };
  } catch (error) {
    console.error("Error submitting positive feedback:", error);
    throw error;
  }
};
